<template>
	<section :class="['marketing-section', `bg-color-${props.backgroundColor}`]">
		<div class="container">
			<div
				class="display-flex flex-wrap-wrap justify-content-center col-12 col-8-md gap-300-lg gap-150 ml-auto mr-auto"
			>
				<h2 :class="['heading-1 text-align-center', titleColor]" v-html="deorphanText(props.title)"></h2>
				<MarketingHeroCta
					class="col-12 col-9-md"
					:center-button="true"
					:component-id="componentId"
					:form-config="leadCaptureConfig"
					:offering-id="offeringId"
					:is-dark-mode="true"
					data-test="hero-lead-capture"
				/>
			</div>
		</div>
	</section>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { deorphanText } from '@filters/shared-filters';
import { LeadCaptureFormConfig } from 'types/layout/lead';
import MarketingHeroCta from '@components/marketing-site/marketing-hero-cta.vue';

interface Props {
	title: string;
	leadCaptureFormConfig: LeadCaptureFormConfig;
	componentId: string;
	offeringId?: string;
	backgroundColor?: string;
}

const props = withDefaults(defineProps<Props>(), { offeringId: undefined, backgroundColor: 'content-primary' });

const titleColor = computed((): string => {
	return props.backgroundColor === 'content-primary' ? 'text-color-white' : 'text-color-content-primary';
});

const leadCaptureConfig = computed((): LeadCaptureFormConfig => {
	return {
		...props.leadCaptureFormConfig,
		buttonText: 'Get started',
		centerButton: true,
		thirdPartyAuthTheme: props.leadCaptureFormConfig.thirdPartyAuthTheme ?? 'SECONDARY'
	};
});
</script>
